// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderPlayControls_root__E5iwC","playControl":"HeaderPlayControls_playControl__VbG7Y","queueControl":"HeaderPlayControls_queueControl__xzCs5"};